<template>
    <ui-table
            url="/backend/toilet/image/list"
            :search="query"
            @onReset="onReset"
            ref="table"
            isNeedIndex
            @handleSelectionChange="handleSelectionChange">
        <template #search-content>
            <el-form
                    ref="ruleFormRef"
                    :model="query"
                    label-width="120px"
                    :inline="true"
                    class=""
            >
                <el-form-item label="地址ID">
                    <el-input v-model="query.toiletId" placeholder="请输入地址ID" clearable></el-input>
                </el-form-item>
            </el-form>
        </template>
        <template #column>
            <el-table-column prop="toilet_id" label="对应地址ID" show-overflow-tooltip/>
            <el-table-column prop="userId" label="用户ID" show-overflow-tooltip>
                <template #default="scope">
                    <span>{{scope.row.user.nickname}}</span>
                </template>
            </el-table-column>
            <el-table-column prop="url" label="图片" show-overflow-tooltip>
                <template #default="scope">
                    <el-image
                            style="width: 50px; height: 50px;position: relative;z-index: 999"
                            :src="scope.row.url"
                            :zoom-rate="1.2"
                            :max-scale="7"
                            :min-scale="0.2"
                            :z-index="9"
                            :preview-teleported="true"
                            :preview-src-list="[scope.row.url]"
                            :initial-index="0"
                            fit="cover"
                    />
                </template>
            </el-table-column>
            <el-table-column prop="create_time" label="上传时间"/>
            <el-table-column label="操作">
                <template #default="scope">
                    <el-popconfirm v-if="!scope.row.status" title="确定要【启用】吗" @confirm="changeImageStatus(scope.row,true)">
                        <template #reference>
                            <el-button type="text">启用</el-button>
                        </template>
                    </el-popconfirm>
                    <el-popconfirm v-if="scope.row.status" title="确定要【禁用】吗" @confirm="changeImageStatus(scope.row,false)">
                        <template #reference>
                            <el-button style="color: #f56c6c" type="text">禁用</el-button>
                        </template>
                    </el-popconfirm>
                </template>
            </el-table-column>
        </template>
    </ui-table>
<!--    <addOrEdit :isShow="isShow" v-if="isShow" ref="addOrEditRef" @closeDialog="closeDialog" @refreshDataList="refresh"></addOrEdit>-->
</template>

<script setup>
    import { defineComponent, onMounted, reactive,ref, nextTick, unref} from 'vue';
    import { ElMessage,ElMessageBox  } from 'element-plus/lib/components';
    // import addOrEdit from './addOrEdit'
    import {changeToiletImageStatus} from '@/api/feedback'
    import {downloadFile} from '@/utils/file'
    let data = ref([])
    let isShow = ref()
    let query = reactive({
        toiletId:'',
    })
    let outerVisible = ref(false)
    let dialogTitle = ref('新增')
    let currentDealerId
    let currentRow = {}
    let isEdit = false
    let delIds = ref([])
    let form = reactive(
        {
            phone:''
        }
    )
    const table = ref(null)
    function refresh(){
        table.value.getList()
    }
    function editDialog(row){//编辑
        outerVisible.value = true
        currentDealerId = row.id
        currentRow = row
        isEdit = true
        dialogTitle.value = '修改'
    }
    const addOrEditRef = ref()
    function closeDialog(){
        isShow.value = false
    }
    function changeImageStatus(data,status){
        let obj = {
            id:data.id,
            status:status
        }
        changeToiletImageStatus(obj).then(data=>{
            if(data.code == 200){
                ElMessage({
                    showClose: true,
                    message: '更新成功',
                    type: 'success',
                })
                refresh()
            }

        })
    }
    function handleClick_edit(id){
        isShow.value = true
        nextTick( () => {
            addOrEditRef.value.init(id)
        })

    }
    function handleSelectionChange(val){//多选
        delIds.value = []
        val.map(item=>{
            delIds.value.push(item.id)
        })
    }
    function handleClick_delete(id){

    }
    function onReset(){//重置
        // let form = unref(ruleFormRef)
        // ruleFormRef.value.resetFields()
        query.factory = ''
        query.onSale=''
        query.nameOrCode=''
    }

    function goodsStatus(id,status){
        let title
        if(status=='Y'){
            title = '确定要上架这款商品吗?'
        }else{
            title = '确定要下架这款商品吗?'
        }
        ElMessageBox.confirm(
            title,
            '提示',
            {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }
        )
            .then(() => {
                goodStatus({id:id,status:status}).then(data => {
                    ElMessage({
                        type: 'success',
                        message: '操作成功',
                    })
                    refresh()
                })
            })
            .catch(() => {
                // ElMessage({
                //     type: 'info',
                //     message: 'Delete canceled',
                // })
            })
    }


</script>
<style lang="scss" scoped>
    .demo-form-inline{
        .el-form-item{
            width: 40%;
        }
    }
    .el-dialog{
        .search-area{
            width:100%;
            display: flex;
            flex-wrap: wrap;
            .search-item{
                margin-bottom:15px;
                span{
                    display: inline-block;
                    width:100px;
                    text-align: right;
                }
                .el-input{
                    width:200px;
                    margin-right: 15px;
                }
            }
        }
        .page-area{
            margin-top:20px;
            display: flex;
            justify-content: flex-end;
        }
    }

</style>
